<div>
    <div class="row">
        <div class="col-xs-12">
            <p class="text-l">
                {{ 'dev.myAccount.giftTicketDownload.subtitle1' | translate }}
                <br />
                <span class="c-dark-grey">
                    {{ 'dev.myAccount.giftTicketDownload.subtitle2' | translate }}
                </span>
            </p>
        </div>
    </div>
    <div class="row mt-32 mb-32">
        <div class="col-xs-12">
            <p class="text-m ttu">
                {{ 'dev.myAccount.giftTicketDownload.selected' | translate }}:
                <span class="title-m ttu">
                    {{ selectedItemsLength$ | async }}
                    {{
                        ((selectedItemsLength$ | async) === 1
                            ? 'dev.myAccount.giftTicketDownload.article'
                            : 'dev.myAccount.giftTicketDownload.articles'
                        ) | translate
                    }}
                </span>
            </p>
        </div>
    </div>
    <div>
        <div class="row mb-24" *ngFor="let item of items; let i = index">
            <div class="col-xs-12 is-flex">
                <div class="align-middle mr-16">
                    <div class="checkbox-item-box">
                        <div class="checkbox-item">
                            <input
                                [id]="'gift-ticket-check-' + i"
                                name="gift-ticket-check"
                                type="checkbox"
                                (change)="toggle($event.target.checked, item.id)"
                            />
                            <label [for]="'gift-ticket-check-' + i">
                                <div class="icon"><svg-icon2 category="common" src="check"></svg-icon2></div>
                            </label>
                        </div>
                    </div>
                </div>
                <item-product-cart class="w-100" [item]="item" [type]="itemType" (selectQuantity)="selectQuantity($event)"></item-product-cart>
            </div>
        </div>
    </div>
    <button class="btn btn-primary btn--full" [disabled]="selectedItemsLength === 0" (click)="download()">
        {{ 'dev.myAccount.giftTicketDownload.button' | translate }}
    </button>
</div>
